import { render } from "./SubscribeIcon.vue?vue&type=template&id=4352e101&scoped=true"
import script from "./SubscribeIcon.vue?vue&type=script&lang=js"
export * from "./SubscribeIcon.vue?vue&type=script&lang=js"

import "./SubscribeIcon.vue?vue&type=style&index=0&id=4352e101&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4352e101"

export default script